import React, { useEffect } from 'react'

// Components
import TextInput from 'components/input/TextInput'

// Data
import {
    qualifications,
    options
} from 'utils/constants/data'

function QualificationStudentIdentifier({
    qualificationOptions,
    values,
    errors,
    touched,
    setFieldValue,
    handleChange,
    handleBlur,
}) {

    useEffect(() => {
        if (values.is_australian_citizen) {
            setFieldValue("specified_visa_class", "")
        }
    }, [values.is_australian_citizen]);

    return (
        <div className='bg-white rounded-lg mx-4 px-6 py-4 md:px-10 md:py-8 space-y-4 sm:space-y-6'>
            <p className='uppercase text-lg sm:text-xl xl:text-2xl mb-2 md:mb-4 font-bold'>1. Qualification Details</p>
            <p className='text-base xl:text-lg mb-2 md:mb-4 '>Select from the list below which qualification(s) you are seeking:</p>
            <div className='grid grid-cols-1 sm:grid-cols-2 gap-4 space-y-2'>
                {qualificationOptions.map((qualification, i) => {
                    return (
                        <div className='flex flex-row items-center space-x-4'>
                            <div>
                                <input
                                    checked={values.qualification === qualification.title}
                                    id={`qualification-radio-btn-${i}`}
                                    name={`qualification-${i}`}
                                    type="radio"
                                    onChange={() => setFieldValue(`qualification`, qualification.title)}
                                    value={values.qualification}
                                    className="mt-1 w-4 h-4 md:w-6 md:h-6 text-blue-600 bg-white border-gray-300 peer-checked:bg-sky-600"
                                    disabled={true}
                                />
                            </div>
                            <p className='text-base xl:text-lg' key={i}>{qualification.title}</p>
                        </div>
                    )
                })}
            </div>
            {(errors?.qualification && touched?.qualification) && errors.qualification && (
                <p className='text-xs sm:text-sm xl:text-base text-red-500'>{errors.qualification}</p>
            )}
            <p className='uppercase text-lg sm:text-xl xl:text-2xl mb-2 md:mb-4 font-bold'>2. Unique Student Identifier (USI)</p>
            <p className='text-base xl:text-lg text-justify mb-2 md:mb-4 '>From 1 January 2015, Interlink Technology Services Pty Ltd can be prevented from issuing you with a nationally recognised VET qualification or statement of attainment when you complete your course if you do not have a Unique Student Identifier (USI). In addition, we are required to include your USI in the data we submit to NCVER. If you have not yet obtained a USI you can apply for it directly at <a className="text-sky-500 underline" href="https://www.usi.gov.au/students/create-your-usi" target="_blank" rel="noopener noreferrer">https://www.usi.gov.au/students/create-your-usi</a> on computer or mobile device.</p>
            <p className='text-base xl:text-lg text-justify mb-2 md:mb-4 '><b>Enter your Unique Student Identifier (USI) (if you already have one)</b>
                <br />You may already have a USI if you have done any nationally recognised training, which could include training at work, completing a first aid course or RSA (Responsible Service of Alcohol) course, getting a white card, or studying at a TAFE or training organisation. It is important that you try to find out whether you already have a USI before attempting to create a new one. You should not have more than one USI. To check if you already have a USI, use the ‘Forgotten USI’ link on the USI website at <a className="text-sky-500 underline" href="https://www.usi.gov.au/faqs/i-have-forgotten-my-usi/" target="_blank" rel="noopener noreferrer">https://www.usi.gov.au/faqs/i-have-forgotten-my-usi/</a>.</p>
            <div className='space-y-4'>
                <TextInput
                    name="usi"
                    label="Unique Student Identifier (USI):"
                    placeholder="Fill in your Unique Student Identifier (USI)..."
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={(errors?.usi && touched?.usi) && errors.usi}
                    value={values.usi}
                />
                <div className='flex flex-col space-y-2'>
                    <p className='font-semibold flex text-base xl:text-lg'>Are you an Australian Citizen?</p>
                    <div className='flex flex-col space-y-2'>
                        {options.map((option, i) => {
                            return (
                                <div className='flex flex-row items-center space-x-3'>
                                    <div>
                                        <input
                                            checked={values.is_australian_citizen === option.value}
                                            id={`citizen-radio-btn-${i}`}
                                            name={`citizen-${i}`}
                                            type="radio"
                                            onChange={() => setFieldValue(`is_australian_citizen`, option.value)}
                                            value={values.is_australian_citizen}
                                            className="mt-1 w-4 h-4 md:w-6 md:h-6 text-blue-600 bg-white border-gray-300 peer-checked:bg-sky-600"
                                        />
                                    </div>
                                    <p className='text-base xl:text-lg' key={i}>{option.title}</p>
                                </div>
                            )
                        })}
                    </div>
                    {(errors?.is_australian_citizen && touched?.is_australian_citizen) && errors.is_australian_citizen && (
                        <p className='text-xs sm:text-sm xl:text-base text-red-500'>{errors.is_australian_citizen}</p>
                    )}
                </div>
                {values.is_australian_citizen === false && (
                    <TextInput
                        name="specified_visa_class"
                        label='If "No", Please Specify VISA Class:'
                        placeholder="Fill in your VISA Class..."
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={(errors?.specified_visa_class && touched?.specified_visa_class) && errors.specified_visa_class}
                        value={values.specified_visa_class}
                    />
                )}
            </div>
        </div>
    )
}

export default QualificationStudentIdentifier